import objectFitImages from 'object-fit-images' ; // object-fit polyfill

import CookieBar from './modules/CookieBar';
import Navigation from './modules/Navigation';
import FormHandler from './modules/FormHandler';
import Carousel from './modules/Carousel';

const $ = jQuery;

const $body = $('body');
const $window = $(window);

const clearLoading = () => {
    $('.loader').remove();
    $body.removeClass('is-loading').addClass('has-loaded');
    clearTimeout(isLoaded);
};

const checkLoadingState = () => {
    if (document.readyState === 'complete') {
        clearLoading();
    } else {
        setTimeout(() => checkLoadingState(), 100);
    }
};

let isLoaded = setTimeout(clearLoading, 600);

$window.on('load', clearLoading);

$(document).ready(() => {
    // Load CookieBar
    new CookieBar;

    // Load Navigation
    new Navigation;

    // Load FormHandler
    new FormHandler;

    // Load Carousel
    new Carousel;

    // Init scroll handlers
    $(window).scroll();

    // Manually clear loading, if not cleared yet
    checkLoadingState();

    // Load object-fit polyfill
    objectFitImages($('.media--fullscreen img'));
});



// WEBPACK FOOTER //
// ./app/themes/template/res/js/src/main.js